<template>
  <div>
    <PageHeader title="Factures" />
    <ClaimInvoices :store-id="selectedStoreId" claim-details-route-prefix="/pos/claims" />
  </div>
</template>

<script>
import ClaimInvoices from "@/components/billing/claim_invoice/ClaimInvoices.vue";
import { PageHeader } from "@estaly/ui";
import { mapState } from "vuex";

export default {
  components: {
    ClaimInvoices,
    PageHeader,
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
  },
};
</script>
